import AbstractService from '@/api/services/AbstractService';
import ResourceCategory from '@/api/objects/ResourceCategory';

class AdminResourceCategoryService extends AbstractService {
  public async all(): Promise<ResourceCategory[]> {
    return this.request('get', this.buildPath('admin/resource-categories'));
  }

  public async list(filters: any, paginate = false): Promise<any> {
    const path = paginate ? this.buildPath('admin/resource-categories-paginated')
      : this.buildPath('admin/resource-categories');

    return this.request(
      'get',
      path,
      filters,
      {},
      undefined,
      paginate,
    );
  }

  public async create(category: Record<string, unknown>): Promise<ResourceCategory> {
    return this.request('post', this.buildPath('admin/resource-category'), [], category);
  }

  public delete(categoryId: number): Promise<any> {
    return this.request('delete', this.buildPath('admin/resource-category/{categoryId}', {
      categoryId,
    }));
  }
}

export default new AdminResourceCategoryService();
